import { CustomFieldDataType } from "@portal/types/entities/custom-field";
import {
  CellRenderProps,
  defaultCellComponents,
} from "@sinecycle/growcomponents";

interface CustomColumnProps {
  value: string;
  type: CustomFieldDataType;
}

function CFCell<T>(props: CellRenderProps<T, CustomColumnProps>) {
  const customField = props.value;

  switch (customField.type) {
    case "STRING":
    case "NUMBER":
    case "BOOLEAN":
    case "DECIMAL":
    case "TEXT":
      return defaultCellComponents.textCell({
        ...props,
        value: customField.value,
        textCellProps: {
          ellipsis: {
            tooltip: {
              placement: "top",
            },
          },
        },
      });
    case "DATE":
    case "DATETIME":
      return defaultCellComponents.dateCell({
        ...props,
        value: customField.value,
      });

    default:
      return defaultCellComponents.textCell({
        ...props,
        value: customField.value,
        textCellProps: {
          ellipsis: {
            tooltip: {
              placement: "top",
            },
          },
        },
      });
  }
}

export { CFCell };
